var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 const { prop, propertyType, features, currentProperty, comparedPrice,
  comparedLot } = options 
__p+='\n\n';
 const commName = MOVE_DATA.community_details &&
  MOVE_DATA.community_details.name || MOVE_DATA.propertyDetails.new_community.name
  
__p+='\n\n';
 const indicators = { price: comparedPrice(currentProperty, prop), sqft:
  comparedLot(currentProperty, prop) } 
__p+='\n\n';
 const target = MOVE_DATA.pageType ===
  'srp' ? `#srp-lead-modal[listing-id='${prop.listing_id}']` :
  `#request-private-showing` 
__p+='\n\n<section class="top-wrapper">\n  ';
 if (prop.photo_url) { 
__p+='\n    <img class="compact-card-image" alt="'+
((__t=( prop.address_display ))==null?'':__t)+
'" />\n  ';
 } else { 
__p+='\n    <div class="image-placeholder"></div>\n  ';
 } 
__p+='\n\n  <div\n    class="data-wrap"\n    data-listingid="'+
((__t=( prop.listing_id ))==null?'':__t)+
'"\n    data-lead_attributes=\'"show_contact_a_lender":true,"lead_type":"showcase","is_lcm_enabled":false,"form_type":"classic","flip_the_market_enabled":false\'\n    data-status="new_plan"\n    data-price="'+
((__t=(prop.price ))==null?'':__t)+
'"\n    data-community_id="'+
((__t=( prop.community_id ))==null?'':__t)+
'"\n    data-community_name="'+
((__t=( prop.community_name ))==null?'':__t)+
'"\n    data-plan_name="'+
((__t=( prop.address_display ))==null?'':__t)+
'"\n    add-lead-form-modal\n    data-lat="'+
((__t=( prop.lat ))==null?'':__t)+
'"\n    data-long="'+
((__t=( prop.long ))==null?'':__t)+
'"\n    data-lead_capture_product="BDX Showcase Plan"\n    data-lead_service="LPS"\n    data-postal_code="'+
((__t=( prop.postal_code ))==null?'':__t)+
'"\n    data-id="'+
((__t=( prop.listing_id ))==null?'':__t)+
'"\n    data-name="'+
((__t=( prop.address_display ))==null?'':__t)+
'"\n    data-full_address_display="'+
((__t=( prop.address_display ))==null?'':__t)+
'"\n    data-property_status="new_community_plan"\n    data-property_type="new_plan"\n    data-new_community_name="'+
((__t=( prop.community_name ))==null?'':__t)+
'"\n    data-address="'+
((__t=( prop.address_display ))==null?'':__t)+
'"\n    data-address_display="'+
((__t=( prop.address_display ))==null?'':__t)+
'"\n    data-toll_free_number="'+
((__t=( prop.toll_free_number ))==null?'':__t)+
'"\n    data-city="'+
((__t=( prop.city ))==null?'':__t)+
'"\n    data-state="'+
((__t=( prop.state ))==null?'':__t)+
'"\n    data-state_code="'+
((__t=( prop.state_code ))==null?'':__t)+
'"\n    data-propertyid="'+
((__t=( prop.listing_id ))==null?'':__t)+
'"\n    data-url="'+
((__t=( prop.ldp_url ))==null?'':__t)+
'"\n    data-photo_url="'+
((__t=( prop.photo_url ))==null?'':__t)+
'"\n  ></div>\n\n  <h2 class="property-name">\n    '+
((__t=( prop.address_display ))==null?'':__t)+
'\n  </h2>\n  <h3>'+
((__t=( commName ))==null?'':__t)+
' Community</h3>\n  <div class="compact-card-address">\n    <span\n      itemprop="address"\n      itemscope\n      itemtype="http://schema.org/PostalAddress"\n    >\n      ';
 if (MOVE_DATA.adobeDTM.listingAddress){ 
__p+='\n      <span class="address" itemprop="streetAddress"\n        >'+
((__t=( MOVE_DATA.adobeDTM.listingAddress ))==null?'':__t)+
'</span\n      >\n      ';
 } else { 
__p+='\n      <span class="address" itemprop="streetAddress"\n        >Address Not Available</span\n      >\n      ';
 } 
__p+='\n    </span>\n  </div>\n\n  <div class="button-group">\n    <div class="cta-wrap">\n      <a\n        href="javascript:void(0)"\n        class="js-qv-contact-agent btn btn-primary round-cta"\n        data-target="'+
((__t=( `${target}` ))==null?'':__t)+
'"\n        data-toggle="modal"\n        data-listing-id="'+
((__t=( prop.listing_id ))==null?'':__t)+
'"\n        compare-prop-cta\n        data-omtag="'+
((__t=( `for_sale:${MOVE_DATA.pageType}:compare_properties:contact_agent` ))==null?'':__t)+
'"\n      >\n        Contact Builder\n      </a>\n    </div>\n    <a\n      href="'+
((__t=( prop.ldp_url ))==null?'':__t)+
'"\n      class="js-hide-ajax-fail btn btn-default margin-left-lg round-cta"\n      target="_blank"\n      rel="nofollow noopener noreferrer"\n      data-omtag="'+
((__t=( `for_sale:${MOVE_DATA.pageType}:compare_properties:view_details` ))==null?'':__t)+
'"\n    >\n      <span>View Details</span>\n    </a>\n  </div>\n\n  <hr />\n</section>\n\n<section class="meta-info">\n  <div class="row vertically-centered">\n    <div class="col-xs-2">\n      from\n    </div>\n    <div class="col-xs-10">\n      <h1 class="price">'+
((__t=( prop.price_display ))==null?'':__t)+
'</h1>\n    </div>\n  </div>\n\n  <div class="row">\n    <div class="col-xs-2"></div>\n    <div class="col-xs-10 estimated-payment">\n      Est. mortgage <span class="estimated-payment-amount">-</span>/mo\n    </div>\n  </div>\n  <div class="row margin-top">\n    <div class="col-xxs-2">\n      <i class="ra ra-bed-o"></i>\n    </div>\n    <div class="col-xxs-10">\n      <h3 class="prop-meta-value">\n        '+
((__t=( prop.beds_display ))==null?'':__t)+
' bed\n      </h3>\n    </div>\n  </div>\n  <div class="row margin-top">\n    <div class="col-xxs-2">\n      <i class="ra ra-bathtub"></i>\n    </div>\n    <div class="col-xxs-10">\n      <h3 class="prop-meta-value">\n        '+
((__t=( prop.baths_display ))==null?'':__t)+
' bath\n      </h3>\n    </div>\n  </div>\n  <div class="row margin-top">\n    <div class="col-xxs-2">\n      <i class="ra ra-size"></i>\n    </div>\n    <div class="col-xxs-10">\n      <h3 class="prop-meta-value">\n        '+
((__t=( prop.sqft_display ))==null?'':__t)+
' sqft\n      </h3>\n    </div>\n  </div>\n  ';
 if(prop.lot_size && prop.lot_size > 0) { 
__p+='\n  <div class="row margin-top">\n    <div class="col-xxs-2">\n      <i class="ra ra-lot-size"></i>\n    </div>\n    <div class="col-xxs-10">\n      <h3 class="prop-meta-value">\n        '+
((__t=( prop.sqft_display ))==null?'':__t)+
' sqft lot\n      </h3>\n    </div>\n  </div>\n  ';
 } 
__p+=' ';
 if(propertyType) { 
__p+='\n  <div class="row margin-top">\n    <div class="col-xxs-2">\n      <i class="ra ra-big-house"></i>\n    </div>\n    <div class="col-xxs-10">\n      <h3 class="prop-meta-value">'+
((__t=( propertyType ))==null?'':__t)+
' sqft lot</h3>\n    </div>\n  </div>\n  ';
 } 
__p+=' ';
 if (indicators.price && indicators.sqft) { 
__p+='\n  <div class="indicator-gap">\n    <ul>\n      <li class="'+
((__t=( indicators.price.klass ))==null?'':__t)+
'">\n        <span>'+
((__t=( indicators.price.text ))==null?'':__t)+
'</span>\n      </li>\n      <li class="'+
((__t=( indicators.sqft.klass ))==null?'':__t)+
'">\n        <span>'+
((__t=( indicators.sqft.text ))==null?'':__t)+
'</span>\n      </li>\n    </ul>\n  </div>\n  ';
 } else { 
__p+='\n  <div class="indicator-gap"></div>\n  ';
 } 
__p+='\n</section>\n<hr />\n\n';
 // Amenities section 
__p+=' ';
 if (features.length) { 
__p+='\n<section class="amenities-features">\n  <h2 class="section-header">Amenities & Features</h2>\n  ';
 const moreFeaturesLength = features.length - 5 
__p+=' ';
 const
  firstFiveFeatures = features.slice(0, 5) 
__p+='\n  <ul class="row">\n    ';
 firstFiveFeatures.forEach((item) => { 
__p+='\n    <li class="col-xs-12">\n      <span>'+
((__t=( item ))==null?'':__t)+
'</span>\n    </li>\n    ';
 }) 
__p+='\n  </ul>\n  ';
 if (moreFeaturesLength > 0) { 
__p+='\n  <div class="margin-top">\n    +'+
((__t=( moreFeaturesLength ))==null?'':__t)+
' more feature'+
((__t=( moreFeaturesLength > 1 ? 's' : ''
    ))==null?'':__t)+
'\n  </div>\n  ';
 } 
__p+='\n</section>\n<hr />\n';
 } 
__p+=' ';
 // Payment section 
__p+='\n<section class="payment-section">\n  <h2 class="section-header margin-bottom-lg compare-payment">Payment</h2>\n  <h3 class="margin-top-lg payment-price">$2,800 / month</h3>\n  <div class="spacer"></div>\n  <div class="row payment-data">\n    <div class="col-xs-9">Principal & Interest</div>\n    <div class="col-xs-3 text-align-right p-i m-left">$2000</div>\n    <div class="spacer"></div>\n    <div class="col-xs-9">Property Tax</div>\n    <div class="col-xs-3 text-align-right p-t m-left">$400</div>\n    <div class="spacer"></div>\n    <div class="col-xs-9">Home Insurance</div>\n    <div class="col-xs-3 text-align-right h-i m-left">$150</div>\n    <div class="spacer"></div>\n    <div class="col-xs-9">HOA Fees</div>\n    <div class="col-xs-3 text-align-right m-left">-</div>\n  </div>\n\n  <div class="spacer"></div>\n\n  <div class="margin-top">\n    <p class="annotation">\n      • 20.00% Down Payment • 30 Year Fixed Loan at 3.808%\n    </p>\n  </div>\n</section>\n\n<hr />\n\n<div class="bottom-button-group">\n  <div class="cta-wrap">\n    <a\n      href="javascript:void(0)"\n      class="js-qv-contact-agent btn btn-primary round-cta"\n      data-target="'+
((__t=( `${target}` ))==null?'':__t)+
'"\n      data-toggle="modal"\n      data-listing-id="'+
((__t=( prop.listing_id ))==null?'':__t)+
'"\n      compare-prop-cta\n      data-omtag="'+
((__t=( `for_sale:${MOVE_DATA.pageType}:compare_properties:contact_agent` ))==null?'':__t)+
'"\n    >\n      Contact Builder\n    </a>\n  </div>\n  <a\n    href="'+
((__t=( prop.ldp_url ))==null?'':__t)+
'"\n    class="js-hide-ajax-fail btn btn-default margin-left-lg round-cta"\n    target="_blank"\n    rel="nofollow noopener noreferrer"\n    data-omtag="'+
((__t=( `for_sale:${MOVE_DATA.pageType}:compare_properties:view_details` ))==null?'':__t)+
'"\n  >\n    <span>View Details</span>\n  </a>\n</div>\n\n<hr />\n';
return __p;
};



// WEBPACK FOOTER //
// ./shared_non_critical/compare-tool/prop-card.jst.ejs